import { Component, Input } from '@angular/core';
import { MerchantModel } from '../../../shared/models/merchant.model';
import { Select } from '@ngxs/store';
import { AppState } from '../../../state/appState';
import { Observable } from 'rxjs';
import { LanguageModel } from '../../../shared/models/language.model';
import { OverviewModesEnum } from '../../../shared/enum/overviewModes.enum';

@Component({
  selector: 'app-card-info',
  templateUrl: './card-info.component.html',
  styleUrls: ['./card-info.component.scss'],
})
export class CardInfoComponent {
  @Input() merchant: MerchantModel;
  @Input() total: number;
  @Input() totalPayment: number;
  @Input() currency: string;
  @Input() currencyPayment: string;

  @Select(AppState.currentLanguage$)
  currentLanguage$: Observable<LanguageModel>;
  @Select(AppState.overviewMode$) overviewMode$: Observable<OverviewModesEnum>;

  public OverviewModesEnum = OverviewModesEnum;

  constructor() {}
}
